import React from 'react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.link/yonzfl" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20BA56] transition-colors" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} data-id="element-171" data-mp="1selbhm6rngna">
      {/* Pulse effect rings */}
      <span className="absolute w-full h-full rounded-full bg-[#25D366] opacity-40 animate-ping" style={{
      animationDuration: '2s'
    }} data-id="element-172" data-mp="1jcc4v7emc7f6"></span>

      {/* WhatsApp official logo */}
      <svg viewBox="0 0 32 32" className="w-8 h-8 relative z-10" fill="currentColor" aria-hidden="true" data-id="element-173" data-mp="2uv50p9ga8qcz">
        <path d="M16.003 0C7.174 0 0 7.174 0 16.003c0 2.823.74 5.577 2.144 7.999L0 32l8.205-2.151a15.945 15.945 0 0 0 7.798 1.99h.001C24.83 31.839 32 24.665 32 15.836 32 7.005 24.83 0 16.003 0zm0 29.16h-.003a13.151 13.151 0 0 1-6.701-1.836l-.481-.286-4.871 1.278 1.301-4.749-.314-.5a13.16 13.16 0 0 1-2.013-7.064c0-7.27 5.92-13.189 13.196-13.189 3.524 0 6.836 1.374 9.326 3.866a13.092 13.092 0 0 1 3.86 9.329c-.001 7.27-5.92 13.151-13.3 13.151zm7.225-9.857c-.395-.198-2.341-1.156-2.704-1.288-.362-.132-.626-.198-.89.198-.264.395-1.021 1.288-1.252 1.552-.231.264-.461.297-.857.099-.395-.198-1.671-.616-3.183-1.965-1.176-1.05-1.971-2.347-2.202-2.742-.231-.395-.025-.609.174-.806.178-.177.395-.461.593-.692.198-.231.264-.395.396-.659.132-.264.066-.494-.033-.692-.099-.198-.89-2.144-1.219-2.935-.321-.77-.647-.666-.89-.679-.231-.012-.494-.014-.758-.014a1.453 1.453 0 0 0-1.054.494c-.362.395-1.384 1.353-1.384 3.299s1.417 3.826 1.615 4.09c.198.264 2.788 4.258 6.752 5.971.943.408 1.679.652 2.253.835.946.301 1.808.259 2.489.157.759-.113 2.341-.957 2.671-1.881.33-.924.33-1.717.231-1.881-.099-.165-.362-.264-.758-.461z" data-id="element-174" data-mp="dan2napxrqk1" />
      </svg>
    </motion.a>;
}